import { } from 'react'
import { MapProvider } from 'react-map-gl'
import BoatMap from './components/Map/BoatMap'
import Sidebar from './components/Sidebar/Sidebar'
import Dashboard from './components/Dashboard/Dashboard'
import PlaybackControls from './components/Playback/PlaybackControls'
import LiveBanner from './components/LiveBanner/LiveBanner'
import LoginPage from './components/Auth/LoginPage'
import AdminDashboard from './components/Admin/AdminDashboard'
import { AppProvider, useApp } from './store/AppContext'

function AppContent() {
    const { currentSchool } = useApp()
    console.log('CURRENT SCHOOL:', currentSchool)

    if (!currentSchool) {
        return <LoginPage />
    }

    if (currentSchool.isAdmin || currentSchool.username === 'admin') {
        return <AdminDashboard />
    }

    return (
        <MapProvider>
            <div className="relative w-full h-screen overflow-hidden bg-slate-900">
                {/* Main Map */}
                <BoatMap />

                {/* Sidebar - Boat Selector */}
                <Sidebar />

                {/* Dashboard - Sensor Data */}
                <Dashboard />

                {/* Live Banner (shows during playback when boats are live) */}
                <LiveBanner />

                {/* Playback Controls */}
                <PlaybackControls />
            </div>
        </MapProvider>
    )
}

function App() {
    return (
        <AppProvider>
            <AppContent />
        </AppProvider>
    )
}

export default App
